(function () {
  var ROOT_SELECTOR = '[data-auxito-pdp-media]';
  var DATA_SELECTOR = '[data-auxito-pdp-media-data]';
  var IMAGE_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
  var DEFAULT_IMAGE_SIZES = '(min-width: 1024px) 61vw, 100vw';
  var DEFERRED_PRELOAD_TIMEOUT = 2600;
  var imagePreloadCache = {};

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function closestWithin(element, selector, root) {
    if (!element || !element.closest) return null;
    var match = element.closest(selector);
    return match && (!root || root.contains(match)) ? match : null;
  }

  function getPointElement(event) {
    if (!event || typeof document.elementFromPoint !== 'function') return null;
    if (typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return null;
    return document.elementFromPoint(event.clientX, event.clientY);
  }

  function getEventMatch(event, selector, root) {
    var match = closestWithin(event && event.target, selector, root);
    if (match) return match;
    return closestWithin(getPointElement(event), selector, root);
  }

  function containsPoint(element, event) {
    if (!element || !event || typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return false;
    var rect = element.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  }

  function getImageFromEvent(event, root) {
    var image = getEventMatch(event, '[data-auxito-pdp-media-image]', root);
    if (image) return image;

    var slide = getEventMatch(event, '[data-auxito-pdp-media-slide]', root);
    if (slide) {
      image = qs('[data-auxito-pdp-media-image]', slide);
      if (image && (containsPoint(image, event) || containsPoint(slide, event))) return image;
    }

    if (!getEventMatch(event, '[data-auxito-pdp-media-viewport]', root)) return null;
    var images = qsa('[data-auxito-pdp-media-image]', root);
    for (var i = 0; i < images.length; i += 1) {
      if (containsPoint(images[i], event)) return images[i];
    }

    return null;
  }

  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.innerText || '');
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cssImageUrl(value) {
    var src = String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/[\r\n]+/g, '');
    return src ? 'url("' + src + '")' : '';
  }

  function isVideoUrl(url) {
    var value = String(url || '').toLowerCase();
    return value.indexOf('youtube.com') !== -1 || value.indexOf('youtu.be') !== -1 || value.indexOf('vimeo.com') !== -1 || value.indexOf('.mp4') !== -1 || value.indexOf('.webm') !== -1;
  }

  function getYouTubeId(url) {
    var value = String(url || '');
    var match = value.match(/[?&]v=([^&]+)/);
    if (match && match[1]) return match[1];
    match = value.match(/youtu\.be\/([^?&]+)/);
    if (match && match[1]) return match[1];
    match = value.match(/\/embed\/([^?&/]+)/);
    if (match && match[1]) return match[1];
    return '';
  }

  function getVimeoId(url) {
    var value = String(url || '');
    var match = value.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match && match[1] ? match[1] : '';
  }

  function getVideoPoster(item) {
    if (item.poster) return item.poster;
    if (item.thumb && !isVideoUrl(item.thumb)) return item.thumb;
    var youtubeId = getYouTubeId(item.url || item.embedUrl);
    return youtubeId ? 'https://img.youtube.com/vi/' + youtubeId + '/hqdefault.jpg' : '';
  }

  function normalizeMediaItem(item, index) {
    var raw = item || {};
    var url = raw.url || raw.src || raw.embedUrl || '';
    var text = raw.text || raw.alt || '';
    var type = raw.type || (isVideoUrl(url) || /video/i.test(text) ? 'video' : 'image');
    var poster = raw.poster || '';

    return {
      type: type === 'video' ? 'video' : 'image',
      id: raw.id != null ? String(raw.id) : 'media-' + index,
      url: url,
      embedUrl: raw.embedUrl || '',
      zoomUrl: raw.zoomUrl || url,
      thumb: raw.thumb || poster || url,
      srcset: raw.srcset || raw.srcSet || '',
      sizes: raw.sizes || DEFAULT_IMAGE_SIZES,
      poster: poster,
      alt: text || raw.alt || '',
      provider: raw.provider || '',
      width: raw.width || 0,
      height: raw.height || 0
    };
  }

  function normalizeMediaList(items) {
    var list = Array.isArray(items) ? items : [];
    return list
      .map(function (item, index) {
        return normalizeMediaItem(item, index);
      })
      .filter(function (item) {
        return item.url || item.type === 'image';
      });
  }

  function getImagePreloadKey(item) {
    if (!item || !item.url) return '';
    return [item.url, item.srcset || '', item.sizes || ''].join('|');
  }

  function ensureImagePreload(item, highPriority) {
    var key = getImagePreloadKey(item);
    var entry;

    if (!key || item.type !== 'image') return Promise.resolve();

    entry = imagePreloadCache[key];
    if (entry) {
      if (highPriority && entry.img && 'fetchPriority' in entry.img) {
        entry.img.fetchPriority = 'high';
      }
      return entry.promise;
    }

    entry = {
      done: false,
      ok: false,
      img: new Image(),
      promise: null
    };
    imagePreloadCache[key] = entry;

    entry.promise = new Promise(function (resolve) {
      var settled = false;

      function finish(ok) {
        if (settled) return;
        settled = true;
        entry.done = true;
        entry.ok = !!ok;
        resolve(entry);
      }

      function finishDecoded() {
        if (entry.img.decode) {
          entry.img.decode().then(function () {
            finish(true);
          }, function () {
            finish(true);
          });
          return;
        }
        finish(true);
      }

      entry.img.onload = finishDecoded;
      entry.img.onerror = function () {
        finish(false);
      };
      entry.img.decoding = 'async';
      if (item.srcset) entry.img.srcset = item.srcset;
      if (item.sizes) entry.img.sizes = item.sizes;
      if ('fetchPriority' in entry.img) {
        entry.img.fetchPriority = highPriority ? 'high' : 'low';
      }
      entry.img.src = item.url;
    });

    return entry.promise;
  }

  function preloadImageItem(item, highPriority, timeout) {
    var promise = ensureImagePreload(item, highPriority);
    if (!timeout) return promise;
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        resolve(imagePreloadCache[getImagePreloadKey(item)] || null);
      }, timeout);

      promise.then(function (entry) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(entry);
      });
    });
  }

  function preloadFirstImage(items) {
    var first = (items || []).filter(function (item) {
      return item.type === 'image' && item.url;
    })[0];
    if (!first) return Promise.resolve();
    return preloadImageItem(first, true, 900);
  }

  function runIdle(callback, delay) {
    return window.setTimeout(function () {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(callback, {
          timeout: 1600
        });
      } else {
        callback();
      }
    }, delay || 0);
  }

  function hydrateImageElement(img, highPriority) {
    if (!img) return;
    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');

    if (highPriority) {
      img.setAttribute('fetchpriority', 'high');
    } else if (!img.getAttribute('fetchpriority')) {
      img.setAttribute('fetchpriority', 'low');
    }

    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }
    if (src && img.getAttribute('src') !== src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }

    if (img.complete && img.naturalWidth) {
      img.classList.add('is-loaded');
      img.classList.remove('is-error');
    }
  }

  function getItemRatio(item) {
    var width = item && parseFloat(item.width);
    var height = item && parseFloat(item.height);
    return width > 0 && height > 0 ? width / height : 0;
  }

  function isProductForcedFullSlide(root, index) {
    return index === 1 && root && root.classList && root.classList.contains('auxito-pdp-media--xp1-lightbar');
  }

  function getItemRatioBucket(item, index, root) {
    if (isProductForcedFullSlide(root, index)) return 'full';
    if (index === 0 || !item || item.type === 'video') return 'full';
    var ratio = getItemRatio(item);
    if (!ratio) return 'peek';
    if (ratio <= 0.82) return 'portrait';
    if (ratio >= 1.35) return 'wide';
    return 'peek';
  }

  function getItemSpan(item, index, root) {
    var bucket = getItemRatioBucket(item, index, root);
    if (bucket === 'full' || bucket === 'wide') return 100;
    if (bucket === 'portrait') return 50;
    return 66.6667;
  }

  function getMediaBackdrop(item) {
    if (!item) return '';
    if (item.type === 'video') return getVideoPoster(item);
    return item.thumb || item.url || item.zoomUrl || '';
  }

  function formatPercent(value) {
    return (Math.round(value * 10000) / 10000) + '%';
  }

  function getSelectedOptionValues(root) {
    var values = [];
    qsa('[data-product-options-container] [data-product-option]', root).forEach(function (el) {
      if ((el.type !== 'radio' && el.type !== 'checkbox') || el.checked) {
        values.push(String(el.value || ''));
      }
    });
    return values;
  }

  function getVariantId(root, variantData) {
    var values = getSelectedOptionValues(root);
    var variants = variantData && variantData.variants ? variantData.variants : null;
    var key;
    var payload;
    var i;

    if (values.length && variants) {
      for (key in variants) {
        if (!Object.prototype.hasOwnProperty.call(variants, key)) continue;
        payload = variants[key];
        if (!payload || !payload.options || payload.options.length !== values.length) continue;
        for (i = 0; i < values.length; i += 1) {
          if (String(payload.options[i]) !== values[i]) break;
        }
        if (i === values.length) {
          syncVariantSelect(root, key);
          return key;
        }
      }
    }

    var checked = qs('[data-product-options-container] .option-value-input:checked', root);
    var optionVariantId = checked && checked.getAttribute('data-variant-id');
    if (optionVariantId) {
      syncVariantSelect(root, optionVariantId);
      return optionVariantId;
    }

    var select = qs('[data-product-options-container] select[data-variants]', root);
    return select && select.value ? String(select.value) : null;
  }

  function syncVariantSelect(root, variantId) {
    var select = qs('[data-product-options-container] select[data-variants]', root);
    if (select && String(select.value) !== String(variantId)) {
      select.value = variantId;
    }
  }

  function getVariantMedia(variantId, variantData, fallbackMedia) {
    var payload = variantData && variantData.variants ? variantData.variants[String(variantId)] : null;
    if (!payload) return fallbackMedia || [];
    if (payload.use_picandvideo && payload.items && payload.items.length) {
      return normalizeMediaList(payload.items);
    }
    if (Array.isArray(payload)) {
      return normalizeMediaList(payload);
    }
    if (payload.images && payload.images.length) {
      return normalizeMediaList(payload.images);
    }
    return fallbackMedia || [];
  }

  function createVideoEmbed(item) {
    var url = item.embedUrl || item.url || '';
    var youtubeId = getYouTubeId(url);
    var vimeoId = getVimeoId(url);

    if (youtubeId) {
      return '<iframe src="https://www.youtube.com/embed/' + escapeHtml(youtubeId) + '?autoplay=1&rel=0&playsinline=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }

    if (vimeoId) {
      return '<iframe src="https://player.vimeo.com/video/' + escapeHtml(vimeoId) + '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }

    if (/\.(mp4|webm)(\?|$)/i.test(url)) {
      return '<video controls autoplay playsinline src="' + escapeHtml(url) + '"></video>';
    }

    if (url) {
      return '<iframe src="' + escapeHtml(url) + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }

    return '';
  }

  function slideHtml(item, index, activeIndex, root) {
    var label = item.alt || 'Product media ' + (index + 1);
    var ratioBucket = getItemRatioBucket(item, index, root);
    var span = formatPercent(getItemSpan(item, index, root));
    var dimensions = item.width && item.height ? ' width="' + escapeHtml(item.width) + '" height="' + escapeHtml(item.height) + '"' : '';
    var isActive = index === activeIndex;
    var backdrop = getMediaBackdrop(item);
    var backdropStyle = backdrop ? ' --apm-slide-bg: ' + escapeHtml(cssImageUrl(backdrop)) + ';' : '';
    var figureClass = 'auxito-pdp-media__figure' + (backdrop ? ' auxito-pdp-media__figure--blurred' : '');

    if (item.type === 'video') {
      return [
        '<article class="auxito-pdp-media__slide" data-auxito-pdp-media-slide data-index="', index, '" data-type="video" data-ratio-bucket="', ratioBucket, '" style="--apm-slide-span: ', span, ';">',
        videoCardHtml(item, label),
        '</article>'
      ].join('');
    }

    if (!item.url) {
      return '<article class="auxito-pdp-media__slide" data-auxito-pdp-media-slide data-index="' + index + '" data-type="image" data-ratio-bucket="' + ratioBucket + '" style="--apm-slide-span: ' + span + ';"><div class="auxito-pdp-media__placeholder">Media pending</div></article>';
    }

    var previewSrc = item.thumb && item.thumb !== item.url ? item.thumb : IMAGE_PLACEHOLDER;
    var srcAttr = isActive ? ' src="' + escapeHtml(item.url) + '"' : ' src="' + escapeHtml(previewSrc) + '" data-src="' + escapeHtml(item.url) + '"';
    var srcsetAttr = item.srcset ? (isActive ? ' srcset="' + escapeHtml(item.srcset) + '"' : ' data-srcset="' + escapeHtml(item.srcset) + '"') : '';
    var sizesAttr = item.srcset ? ' sizes="' + escapeHtml(item.sizes || DEFAULT_IMAGE_SIZES) + '"' : '';
    var priority = isActive ? 'high' : 'low';
    var decoding = isActive ? 'sync' : 'async';

    return [
      '<article class="auxito-pdp-media__slide" data-auxito-pdp-media-slide data-index="', index, '" data-type="image" data-ratio-bucket="', ratioBucket, '" style="--apm-slide-span: ', span, ';', backdropStyle, '">',
      '<figure class="', figureClass, '">',
      '<img class="auxito-pdp-media__image"', srcAttr, srcsetAttr, sizesAttr, ' alt="', escapeHtml(label), '"', dimensions, ' loading="', isActive ? 'eager' : 'lazy', '" fetchpriority="', priority, '" decoding="', decoding, '" draggable="false" data-auxito-pdp-media-image data-zoom-src="', escapeHtml(item.zoomUrl || item.url), '">',
      '</figure>',
      '</article>'
    ].join('');
  }

  function videoCardHtml(item, label) {
    var poster = getVideoPoster(item);
    return [
      '<div class="auxito-pdp-media__video-card" data-auxito-pdp-media-video-card>',
      '<button class="auxito-pdp-media__video-poster" type="button" data-auxito-pdp-media-play aria-label="Play ', escapeHtml(label), '">',
      poster ? '<img src="' + escapeHtml(poster) + '" alt="' + escapeHtml(label) + '" loading="lazy" decoding="async" fetchpriority="low">' : '<span class="auxito-pdp-media__placeholder">Video</span>',
      '<span class="auxito-pdp-media__play" aria-hidden="true"></span>',
      '</button>',
      item.url ? '<a class="auxito-pdp-media__video-link" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">Open video</a>' : '',
      '</div>'
    ].join('');
  }

  function thumbHtml(item, index, activeIndex) {
    var label = item.alt || 'Product media ' + (index + 1);
    var thumb = item.type === 'video' ? getVideoPoster(item) : item.thumb || item.url;
    var shouldLoadThumb = index < 4 || Math.abs(index - activeIndex) <= 2;
    var thumbImg = '';

    if (thumb) {
      thumbImg = shouldLoadThumb
        ? '<img src="' + escapeHtml(thumb) + '" alt="' + escapeHtml(label) + '" loading="lazy" decoding="async" fetchpriority="low" data-auxito-pdp-thumb-image>'
        : '<img src="' + IMAGE_PLACEHOLDER + '" data-src="' + escapeHtml(thumb) + '" alt="' + escapeHtml(label) + '" loading="lazy" decoding="async" fetchpriority="low" data-auxito-pdp-thumb-image>';
    }

    return [
      '<button class="auxito-pdp-media__thumb', index === activeIndex ? ' is-active' : '', '" type="button" data-auxito-pdp-media-thumb="', index, '" aria-label="Show ', escapeHtml(label), '">',
      thumbImg || '<span class="auxito-pdp-media__thumb-placeholder"></span>',
      item.type === 'video' ? '<span class="auxito-pdp-media__thumb-video" aria-hidden="true"></span>' : '',
      '</button>'
    ].join('');
  }

  function initMedia(root) {
    if (!root) return;
    if (root.__auxitoPdpMediaInited && root.__auxitoPdpMediaApi) return;
    root.__auxitoPdpMediaInited = true;

    var data = parseJson(qs(DATA_SELECTOR, root)) || {};
    var scopeRoot = root.closest('.product--outer') || root.parentNode || document;
    var variantData = parseJson(qs('script[data-auxito-variant-gallery]', scopeRoot));
    var initialItems = normalizeMediaList(data.initialMedia && data.initialMedia.length ? data.initialMedia : data.productMedia);
    var state = {
      allItems: initialItems,
      items: [],
      mode: 'overview',
      sectionIndex: {
        overview: 0,
        video: 0
      },
      productMedia: normalizeMediaList(data.productMedia),
      index: 0,
      variantId: data.selectedVariantId ? String(data.selectedVariantId) : null,
      applyTimer: null,
      deferredImageTimer: null,
      deferredThumbTimer: null,
      touchStartX: null,
      touchStartY: null,
      pointerStartX: null,
      pointerStartY: null,
      pointerId: null,
      pointerActive: false,
      pointerHandledAt: 0,
      mouseStartX: null,
      mouseStartY: null,
      didSwipe: false,
      swipeResetTimer: null
    };

    var track = qs('[data-auxito-pdp-media-track]', root);
    var thumbs = qs('[data-auxito-pdp-media-thumbs]', root);
    var ribbon = qs('[data-auxito-pdp-media-ribbon]', root);
    var counter = qs('[data-auxito-pdp-media-counter]', root);
    var prev = qs('[data-auxito-pdp-media-prev]', root);
    var next = qs('[data-auxito-pdp-media-next]', root);
    var viewport = qs('[data-auxito-pdp-media-viewport]', root);
    var zoom = qs('[data-auxito-pdp-media-zoom]', root);
    var zoomImage = qs('[data-auxito-pdp-media-zoom-image]', root);
    var zoomHome = zoom ? zoom.parentNode : null;

    function isTwoUpTrack() {
      // Mobile stays single-frame; tablet and desktop can show two image frames.
      return window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
    }

    function getVisibleItems() {
      return state.items.length ? state.items : [{
        type: 'image',
        id: 'placeholder',
        url: '',
        alt: 'Media pending'
      }];
    }

    function getTrackSpanBefore(index) {
      var items = getVisibleItems();
      var offset = 0;
      var limit = Math.min(index, items.length);
      for (var i = 0; i < limit; i += 1) {
        offset += getItemSpan(items[i], i, root);
      }
      return offset;
    }

    function getTrackTotalSpan() {
      var items = getVisibleItems();
      var total = 0;
      for (var i = 0; i < items.length; i += 1) {
        total += getItemSpan(items[i], i, root);
      }
      return total;
    }

    function applySlideLayoutHints() {
      qsa('[data-auxito-pdp-media-slide]', root).forEach(function (slide) {
        var index = parseInt(slide.getAttribute('data-index'), 10);
        var item = getVisibleItems()[index];
        if (!item) return;
        slide.style.setProperty('--apm-slide-span', formatPercent(getItemSpan(item, index, root)));
        slide.setAttribute('data-ratio-bucket', getItemRatioBucket(item, index, root));
      });
    }

    function getTrackOffset(index) {
      if (!isTwoUpTrack()) return 'calc(' + index + ' * -100%)';
      if (index <= 0) return '0%';
      var offset = getTrackSpanBefore(index);
      var maxOffset = Math.max(0, getTrackTotalSpan() - 100);
      return '-' + formatPercent(Math.min(offset, maxOffset));
    }

    function updateTrackOffset() {
      track.style.setProperty('--apm-index', String(state.index));
      track.style.setProperty('--apm-offset', getTrackOffset(state.index));
    }

    function updateAmbientBackdrop() {
      var item = state.items[state.index] || state.items[0] || state.allItems[0];
      var backdrop = getMediaBackdrop(item);

      if (backdrop) {
        root.style.setProperty('--apm-ambient-image', cssImageUrl(backdrop));
        root.classList.add('has-ambient');
      } else {
        root.style.removeProperty('--apm-ambient-image');
        root.classList.remove('has-ambient');
      }
    }

    function getSectionItems(mode) {
      var type = mode === 'video' ? 'video' : 'image';
      return state.allItems.filter(function (item) {
        return item.type === type;
      });
    }

    function hasSectionItems(mode) {
      return getSectionItems(mode).length > 0;
    }

    function findItemIndexById(items, id) {
      var targetId = String(id == null ? '' : id).trim();
      var list = Array.isArray(items) ? items : [];
      var i;

      if (!targetId) return -1;
      for (i = 0; i < list.length; i += 1) {
        if (String(list[i].id) === targetId) return i;
      }
      return -1;
    }

    function applyInitialSelectedMedia() {
      var selectedMediaId = data.selectedMediaId;
      var allItemsIndex = findItemIndexById(state.allItems, selectedMediaId);
      var selectedItem;
      var sectionItems;
      var sectionIndex;

      if (allItemsIndex < 0) return false;
      selectedItem = state.allItems[allItemsIndex];
      state.mode = selectedItem.type === 'video' ? 'video' : 'overview';
      sectionItems = getSectionItems(state.mode);
      sectionIndex = findItemIndexById(sectionItems, selectedMediaId);
      if (sectionIndex < 0) return false;
      state.sectionIndex[state.mode] = sectionIndex;
      state.index = sectionIndex;
      return true;
    }

    function refreshSection(resetIndex) {
      var nextItems = getSectionItems(state.mode);
      if (!nextItems.length && state.mode === 'video') {
        state.mode = 'overview';
        nextItems = getSectionItems(state.mode);
      }
      state.items = nextItems;
      if (resetIndex) {
        state.index = 0;
      } else {
        state.index = state.sectionIndex[state.mode] || 0;
      }
      render();
    }

    function switchSection(mode) {
      if (mode === state.mode) return;
      if (mode === 'video' && !hasSectionItems('video')) return;
      state.sectionIndex[state.mode] = state.index;
      state.mode = mode;
      state.items = getSectionItems(state.mode);
      state.index = state.sectionIndex[state.mode] || 0;
      render();
      pauseInactiveVideos();
    }

    function getSlideImage(index) {
      var slides = qsa('[data-auxito-pdp-media-slide]', root);
      for (var i = 0; i < slides.length; i += 1) {
        if (parseInt(slides[i].getAttribute('data-index'), 10) === index) {
          return qs('[data-auxito-pdp-media-image]', slides[i]);
        }
      }
      return null;
    }

    function hydrateSlideImage(index, highPriority) {
      if (index < 0 || index > state.items.length - 1) return;
      hydrateImageElement(getSlideImage(index), highPriority);
    }

    function normalizeIndex(index) {
      if (!state.items.length) return 0;
      if (index < 0) return state.items.length - 1;
      if (index > state.items.length - 1) return 0;
      return index;
    }

    function prepareImageForIndex(index, highPriority, timeout) {
      var item;

      if (index < 0 || index > state.items.length - 1) return Promise.resolve();
      item = state.items[index];
      if (!item || item.type !== 'image') return Promise.resolve();

      hydrateSlideImage(index, highPriority);
      return preloadImageItem(item, highPriority, timeout || DEFERRED_PRELOAD_TIMEOUT);
    }

    function warmNearbyImages() {
      prepareImageForIndex(state.index + 1, false, DEFERRED_PRELOAD_TIMEOUT);
      if (isTwoUpTrack()) {
        prepareImageForIndex(state.index - 1, false, DEFERRED_PRELOAD_TIMEOUT);
      }
    }

    function hydrateDeferredThumbs() {
      if (!areThumbsVisible()) return;
      qsa('[data-auxito-pdp-thumb-image][data-src]', root).forEach(function (img) {
        hydrateImageElement(img, false);
      });
    }

    function areThumbsVisible() {
      if (!thumbs) return false;
      return !!(thumbs.offsetWidth || thumbs.offsetHeight || thumbs.getClientRects().length);
    }

    function scheduleDeferredHydration() {
      if (state.deferredImageTimer) clearTimeout(state.deferredImageTimer);
      if (state.deferredThumbTimer) clearTimeout(state.deferredThumbTimer);

      state.deferredImageTimer = runIdle(function () {
        warmNearbyImages();
      }, isTwoUpTrack() ? 320 : 480);

      if (areThumbsVisible()) {
        state.deferredThumbTimer = runIdle(hydrateDeferredThumbs, 1200);
      }
    }

    function hydrateActiveMedia() {
      hydrateSlideImage(state.index, true);
      if (isTwoUpTrack() && state.index > 0) {
        hydrateSlideImage(state.index + 1, false);
      }
      scheduleDeferredHydration();
    }

    function render() {
      var renderItems = state.items.length ? state.items : [{
          type: 'image',
          id: 'placeholder',
          url: '',
          alt: 'Media pending'
        }];

      if (state.index < 0) state.index = 0;
      if (state.index > renderItems.length - 1) state.index = renderItems.length - 1;

      track.innerHTML = renderItems.map(function (item, index) {
        return slideHtml(item, index, state.index, root);
      }).join('');
      thumbs.innerHTML = renderItems.map(function (item, index) {
        return thumbHtml(item, index, state.index);
      }).join('');
      applySlideLayoutHints();
      update();
    }

    function update() {
      var hasVideo = hasSectionItems('video');
      updateTrackOffset();
      updateAmbientBackdrop();
      ribbon.textContent = state.mode === 'video' ? 'Video' : 'Overview';

      qsa('[data-auxito-pdp-media-thumb]', root).forEach(function (button, index) {
        button.classList.toggle('is-active', index === state.index);
      });

      if (prev) prev.disabled = state.items.length <= 1;
      if (next) next.disabled = state.items.length <= 1;

      if (counter) {
        if (state.items.length > 1) {
          counter.textContent = (state.index + 1) + '/' + state.items.length;
          counter.hidden = false;
        } else {
          counter.hidden = true;
        }
      }

      qsa('[data-auxito-pdp-media-tab]', root).forEach(function (button) {
        var target = button.getAttribute('data-auxito-pdp-media-tab');
        var selected = target === state.mode;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (target === 'video') button.disabled = !hasVideo;
      });

      hydrateActiveMedia();
    }

    function goTo(index) {
      var target;

      if (!state.items.length) return;
      target = normalizeIndex(index);
      prepareImageForIndex(target, true, DEFERRED_PRELOAD_TIMEOUT);
      state.index = target;
      state.sectionIndex[state.mode] = state.index;
      update();
      pauseInactiveVideos();
    }

    function markSwipeHandled() {
      state.didSwipe = true;
      if (state.swipeResetTimer) clearTimeout(state.swipeResetTimer);
      state.swipeResetTimer = setTimeout(function () {
        state.didSwipe = false;
      }, 260);
    }

    function handleSwipe(deltaX, deltaY) {
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY || 0);
      if (absX < 36 || absX < absY * 1.15) return false;
      markSwipeHandled();
      goTo(deltaX > 0 ? state.index - 1 : state.index + 1);
      return true;
    }

    function pauseInactiveVideos() {
      qsa('[data-auxito-pdp-media-video-card]', root).forEach(function (card) {
        var slide = card.closest ? card.closest('[data-auxito-pdp-media-slide]') : null;
        var index = slide ? parseInt(slide.getAttribute('data-index'), 10) : -1;
        if (!isFinite(index)) return;
        if (index === state.index) return;
        var item = state.items[index];
        if (!item || item.type !== 'video') return;
        if (!qs('[data-auxito-pdp-media-play]', card)) {
          card.outerHTML = videoCardHtml(item, item.alt || 'Product media ' + (index + 1));
        }
      });
    }

    function playVideo(button) {
      var slide = button.closest('[data-auxito-pdp-media-slide]');
      var index = slide ? parseInt(slide.getAttribute('data-index'), 10) : state.index;
      var item = state.items[index];
      var card = button.closest('[data-auxito-pdp-media-video-card]');
      var embed = item ? createVideoEmbed(item) : '';
      if (!card || !embed) return;
      card.innerHTML = embed + (item.url ? '<a class="auxito-pdp-media__video-link" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">Open video</a>' : '');
    }

    // Keep zoom above theme header/sticky stacks by escaping the PDP layout tree.
    function mountZoom() {
      if (!zoom || !document.body || zoom.parentNode === document.body) return;
      document.body.appendChild(zoom);
    }

    function restoreZoom() {
      if (!zoom || !zoomHome || !zoomHome.isConnected || zoom.parentNode === zoomHome) return;
      zoomHome.appendChild(zoom);
    }

    function openZoom(img) {
      if (!zoom || !zoomImage || !img) return;
      mountZoom();
      zoomImage.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      zoomImage.alt = img.alt || '';
      zoom.hidden = false;
      zoom.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('auxito-pdp-media-zoom-open');
    }

    function closeZoom() {
      if (!zoom || !zoomImage) return;
      zoom.hidden = true;
      zoom.setAttribute('aria-hidden', 'true');
      zoomImage.removeAttribute('src');
      document.documentElement.classList.remove('auxito-pdp-media-zoom-open');
      restoreZoom();
    }

    function applyVariant(variantId, immediate) {
      if (!variantId || String(variantId) === String(state.variantId)) return;
      var nextItems = getVariantMedia(variantId, variantData, state.productMedia);
      if (!nextItems.length) return;
      state.variantId = String(variantId);
      root.classList.add('is-loading');
      state.allItems = nextItems;
      state.sectionIndex.overview = 0;
      state.sectionIndex.video = 0;
      refreshSection(true);
      preloadFirstImage(nextItems).then(function () {
        root.classList.remove('is-loading');
      });
      if (immediate) root.classList.remove('is-loading');
    }

    function scheduleVariantApply(delay) {
      if (state.applyTimer) clearTimeout(state.applyTimer);
      state.applyTimer = setTimeout(function () {
        applyVariant(getVariantId(scopeRoot, variantData), false);
      }, typeof delay === 'number' ? delay : 0);
    }

    root.__auxitoPdpMediaApi = {
      previous: function () {
        goTo(state.index - 1);
      },
      next: function () {
        goTo(state.index + 1);
      },
      thumb: function (index) {
        goTo(index);
      },
      play: function (button) {
        playVideo(button);
      },
      openImage: function (image) {
        if (state.didSwipe) {
          state.didSwipe = false;
          return;
        }
        openZoom(image);
      },
      tab: function (mode) {
        switchSection(mode === 'video' ? 'video' : 'overview');
      }
    };

    root.addEventListener('click', function (event) {
      if (event.__auxitoPdpMediaHandled) return;
      var prevControl = getEventMatch(event, '[data-auxito-pdp-media-prev]', root);
      var nextControl = getEventMatch(event, '[data-auxito-pdp-media-next]', root);
      var thumb = getEventMatch(event, '[data-auxito-pdp-media-thumb]', root);
      var play = getEventMatch(event, '[data-auxito-pdp-media-play]', root);
      var tab = getEventMatch(event, '[data-auxito-pdp-media-tab]', root);
      var close = getEventMatch(event, '[data-auxito-pdp-media-zoom-close]', root);
      var image = !prevControl && !nextControl && !thumb && !play && !tab && !close ? getImageFromEvent(event, root) : null;

      if (thumb) {
        event.preventDefault();
        goTo(parseInt(thumb.getAttribute('data-auxito-pdp-media-thumb'), 10));
      } else if (play) {
        event.preventDefault();
        playVideo(play);
      } else if (image) {
        event.preventDefault();
        if (state.didSwipe) {
          state.didSwipe = false;
          return;
        }
        openZoom(image);
      } else if (tab) {
        event.preventDefault();
        if (tab.getAttribute('data-auxito-pdp-media-tab') === 'video') {
          switchSection('video');
        } else {
          switchSection('overview');
        }
      } else if (close) {
        event.preventDefault();
        closeZoom();
      }
    });

    if (zoom) {
      zoom.addEventListener('click', function (event) {
        var close = event.target.closest ? event.target.closest('[data-auxito-pdp-media-zoom-close]') : null;
        if (event.target === zoom || close) closeZoom();
      });
    }

    root.addEventListener('load', function (event) {
      var image = event.target;
      if (!image || !image.matches || !image.matches('[data-auxito-pdp-media-image]')) return;
      if (!image.naturalWidth || !image.naturalHeight) return;
      image.classList.add('is-loaded');
      image.classList.remove('is-error');
      var slide = image.closest ? image.closest('[data-auxito-pdp-media-slide]') : null;
      var index = slide ? parseInt(slide.getAttribute('data-index'), 10) : -1;
      var item = state.items[index];
      if (!item) return;
      if (parseFloat(item.width) === image.naturalWidth && parseFloat(item.height) === image.naturalHeight) return;
      item.width = image.naturalWidth;
      item.height = image.naturalHeight;
      applySlideLayoutHints();
      updateTrackOffset();
    }, true);

    root.addEventListener('error', function (event) {
      var image = event.target;
      if (!image || !image.matches || !image.matches('[data-auxito-pdp-media-image]')) return;
      image.classList.add('is-error');
    }, true);

    if (prev) {
      prev.addEventListener('click', function (event) {
        if (event.__auxitoPdpMediaHandled) return;
        goTo(state.index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        if (event.__auxitoPdpMediaHandled) return;
        goTo(state.index + 1);
      });
    }

    if (viewport && window.PointerEvent) {
      viewport.addEventListener('pointerdown', function (event) {
        if (event.button != null && event.button !== 0) return;
        if (event.isPrimary === false) return;
        state.pointerStartX = event.clientX;
        state.pointerStartY = event.clientY;
        state.pointerId = event.pointerId;
        state.pointerActive = true;
        state.pointerHandledAt = Date.now();
        if (viewport.setPointerCapture) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (e) {}
        }
      });

      viewport.addEventListener('pointerup', function (event) {
        if (!state.pointerActive) return;
        if (state.pointerId != null && event.pointerId !== state.pointerId) return;
        var deltaX = event.clientX - state.pointerStartX;
        var deltaY = event.clientY - state.pointerStartY;
        state.pointerStartX = null;
        state.pointerStartY = null;
        state.pointerId = null;
        state.pointerActive = false;
        state.pointerHandledAt = Date.now();
        if (viewport.releasePointerCapture) {
          try {
            viewport.releasePointerCapture(event.pointerId);
          } catch (e) {}
        }
        handleSwipe(deltaX, deltaY);
      });

      viewport.addEventListener('pointercancel', function () {
        state.pointerStartX = null;
        state.pointerStartY = null;
        state.pointerId = null;
        state.pointerActive = false;
        state.pointerHandledAt = Date.now();
      });
    }

    if (viewport) {
      viewport.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        if (Date.now() - state.pointerHandledAt < 400) return;
        state.mouseStartX = event.clientX;
        state.mouseStartY = event.clientY;
      });

      document.addEventListener('mouseup', function (event) {
        if (state.mouseStartX == null) return;
        if (Date.now() - state.pointerHandledAt < 400) {
          state.mouseStartX = null;
          state.mouseStartY = null;
          return;
        }
        var deltaX = event.clientX - state.mouseStartX;
        var deltaY = event.clientY - state.mouseStartY;
        state.mouseStartX = null;
        state.mouseStartY = null;
        handleSwipe(deltaX, deltaY);
      });
    }

    if (viewport && !window.PointerEvent) {
      viewport.addEventListener('touchstart', function (event) {
        state.touchStartX = event.touches && event.touches.length ? event.touches[0].clientX : null;
        state.touchStartY = event.touches && event.touches.length ? event.touches[0].clientY : null;
      }, { passive: true });

      viewport.addEventListener('touchend', function (event) {
        if (state.touchStartX == null || !event.changedTouches || !event.changedTouches.length) return;
        var delta = event.changedTouches[0].clientX - state.touchStartX;
        var deltaY = event.changedTouches[0].clientY - state.touchStartY;
        state.touchStartX = null;
        state.touchStartY = null;
        handleSwipe(delta, deltaY);
      }, { passive: true });
    }

    window.addEventListener('resize', function () {
      updateTrackOffset();
      scheduleDeferredHydration();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') goTo(state.index - 1);
      if (event.key === 'ArrowRight') goTo(state.index + 1);
      if (event.key === 'Escape') closeZoom();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && zoom && !zoom.hidden) closeZoom();
    });

    var variantSelect = qs('[data-product-options-container] select[data-variants]', scopeRoot);
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        scheduleVariantApply(0);
      });
    }

    var optionsContainer = qs('[data-product-options-container]', scopeRoot);
    if (optionsContainer) {
      optionsContainer.addEventListener('change', function (event) {
        var target = event.target;
        if (target && target.matches && (target.matches('[data-product-option]') || target.matches('.option-value-input'))) {
          scheduleVariantApply(0);
        }
      });
    }

    if (window.jQuery && window.jQuery(window).on) {
      window.jQuery(window).on('product-variant-switch.auxitoPdpMedia', function (event, eventData) {
        if (eventData && eventData.variant && eventData.variant.id) {
          if (!variantData && eventData.variant.featured_media && eventData.variant.featured_media.id) {
            state.variantId = String(eventData.variant.id);
            goToItemId(eventData.variant.featured_media.id);
            return;
          }
          applyVariant(String(eventData.variant.id), false);
        }
      });
    }

    function goToItemId(id) {
      var stringId = String(id);
      var target = null;
      var i;
      for (i = 0; i < state.allItems.length; i += 1) {
        if (String(state.allItems[i].id) === stringId) {
          target = state.allItems[i];
          break;
        }
      }
      if (!target) return;
      state.mode = target.type === 'video' ? 'video' : 'overview';
      state.items = getSectionItems(state.mode);
      for (i = 0; i < state.items.length; i += 1) {
        if (String(state.items[i].id) === stringId) {
          state.index = i;
          state.sectionIndex[state.mode] = i;
          render();
          return;
        }
      }
    }

    refreshSection(!applyInitialSelectedMedia());
  }

  function installGlobalClickFallback() {
    if (document.__auxitoPdpMediaGlobalClickFallback) return;
    document.__auxitoPdpMediaGlobalClickFallback = true;

    document.addEventListener('click', function (event) {
      if (event.__auxitoPdpMediaHandled || !event.target || !event.target.closest) return;

      var root = event.target.closest(ROOT_SELECTOR);
      if (!root) return;
      if (!root.__auxitoPdpMediaApi) initMedia(root);

      var api = root.__auxitoPdpMediaApi;
      if (!api) return;

      var prev = getEventMatch(event, '[data-auxito-pdp-media-prev]', root);
      var next = getEventMatch(event, '[data-auxito-pdp-media-next]', root);
      var thumb = getEventMatch(event, '[data-auxito-pdp-media-thumb]', root);
      var play = getEventMatch(event, '[data-auxito-pdp-media-play]', root);
      var tab = getEventMatch(event, '[data-auxito-pdp-media-tab]', root);
      var image = !prev && !next && !thumb && !play && !tab ? getImageFromEvent(event, root) : null;

      if (prev && root.contains(prev)) {
        event.__auxitoPdpMediaHandled = true;
        event.preventDefault();
        event.stopPropagation();
        api.previous();
        return;
      }

      if (next && root.contains(next)) {
        event.__auxitoPdpMediaHandled = true;
        event.preventDefault();
        event.stopPropagation();
        api.next();
        return;
      }

      if (thumb && root.contains(thumb)) {
        event.__auxitoPdpMediaHandled = true;
        event.preventDefault();
        event.stopPropagation();
        api.thumb(parseInt(thumb.getAttribute('data-auxito-pdp-media-thumb'), 10));
        return;
      }

      if (play && root.contains(play)) {
        event.__auxitoPdpMediaHandled = true;
        event.preventDefault();
        event.stopPropagation();
        api.play(play);
        return;
      }

      if (image && root.contains(image)) {
        event.__auxitoPdpMediaHandled = true;
        event.preventDefault();
        event.stopPropagation();
        api.openImage(image);
        return;
      }

      if (tab && root.contains(tab)) {
        event.__auxitoPdpMediaHandled = true;
        event.preventDefault();
        event.stopPropagation();
        api.tab(tab.getAttribute('data-auxito-pdp-media-tab'));
      }
    }, true);
  }

  function initAll(root) {
    qsa(ROOT_SELECTOR, root || document).forEach(initMedia);
  }

  window.auxitoPdpMedia = {
    version: '2026-04-28-nonblocking-media-preload',
    reinit: function (root) {
      initAll(root || document);
    }
  };

  function scheduleInitAll(delay) {
    setTimeout(function () {
      initAll(document);
    }, delay);
  }

  installGlobalClickFallback();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  window.addEventListener('pageshow', function () {
    scheduleInitAll(0);
    scheduleInitAll(300);
  });

  window.addEventListener('load', function () {
    scheduleInitAll(0);
    scheduleInitAll(800);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleInitAll(0);
  });
})();
